import aggressiveImg from 'assets/images/risk-assessment/aggressive.png'
import balancedImg from 'assets/images/risk-assessment/balanced.png'
import cautiousImg from 'assets/images/risk-assessment/cautious.png'
import defensiveImg from 'assets/images/risk-assessment/defensive.png'
import b2BomberImg from 'assets/images/risk-assessment/b2-bomber.png'

export const riskProfiles = [
  {
    slug: 'aggressive',
    displayName: 'Aggressive',
    riskLevel: 10,
    accentHex: '#FF2F32',
    subtitle: 'RISK LEVEL 10/10',
    description:
      'You aim for the highest possible growth, fully accepting the increased volatility that comes with it.',
    descriptionSecondary:
      'Historically, a portfolio dominated by U.S., foreign, and emerging market stocks with minimal bond exposure.',
    image: b2BomberImg,
  },
  {
    slug: 'aggressive',
    displayName: 'Aggressive',
    riskLevel: 9,
    accentHex: '#FF2F32',
    subtitle: 'RISK LEVEL 9/10',
    description:
      'You aim for the highest possible growth, fully accepting the increased volatility that comes with it.',
    descriptionSecondary:
      'Historically, a portfolio dominated by U.S., foreign, and emerging market stocks with minimal bond exposure.',
    image: b2BomberImg,
  },
  {
    slug: 'adventurous',
    displayName: 'Adventurous',
    riskLevel: 8,
    accentHex: '#FF2F32',
    subtitle: 'RISK LEVEL 8/10',
    description:
      'You are comfortable taking on more risk in pursuit of higher returns and can tolerate significant market fluctuations.',
    descriptionSecondary:
      'Your portfolio is heavily weighted toward stocks from the U.S., foreign developed markets, and emerging markets.',
    image: aggressiveImg,
  },
  {
    slug: 'adventurous',
    displayName: 'Adventurous',
    riskLevel: 7,
    accentHex: '#FF2F32',
    subtitle: 'RISK LEVEL 7/10',
    description:
      'You are comfortable taking on more risk in pursuit of higher returns and can tolerate significant market fluctuations.',
    descriptionSecondary:
      'Your portfolio is heavily weighted toward stocks from the U.S., foreign developed markets, and emerging markets.',
    image: aggressiveImg,
  },
  {
    slug: 'balanced',
    displayName: 'Balanced',
    riskLevel: 6,
    accentHex: '#2370ED',
    subtitle: 'RISK LEVEL 6/10',
    description:
      'You seek a balance between growth and stability, with market movements that feel manageable.',
    descriptionSecondary:
      'Your portfolio includes U.S. stocks for long-term growth potential and corporate bonds to help stabilize risk and generate interest.',
    image: balancedImg,
  },
  {
    slug: 'balanced',
    displayName: 'Balanced',
    riskLevel: 5,
    accentHex: '#2370ED',
    subtitle: 'RISK LEVEL 5/10',
    description:
      'You seek a balance between growth and stability, with market movements that feel manageable.',
    descriptionSecondary:
      'Your portfolio includes U.S. stocks for long-term growth potential and corporate bonds to help stabilize risk and generate interest.',
    image: balancedImg,
  },
  {
    slug: 'cautious',
    displayName: 'Cautious',
    riskLevel: 4,
    accentHex: '#2370ED',
    subtitle: 'RISK LEVEL 4/10',
    description:
      'You value stability but are open to some level of market exposure to achieve modest growth. You tolerate some volatility, but significant downturns make you uneasy.',
    descriptionSecondary:
      'Your portfolio is balanced between stocks—including a small portion in foreign and emerging markets—and bonds.',
    image: cautiousImg,
  },
  {
    slug: 'cautious',
    displayName: 'Cautious',
    riskLevel: 3,
    accentHex: '#2370ED',
    subtitle: 'RISK LEVEL 3/10',
    description:
      'You value stability but are open to some level of market exposure to achieve modest growth. You tolerate some volatility, but significant downturns make you uneasy.',
    descriptionSecondary:
      'Your portfolio is balanced between stocks—including a small portion in foreign and emerging markets—and bonds.',
    image: cautiousImg,
  },
  {
    slug: 'defensive',
    displayName: 'Defensive',
    riskLevel: 2,
    accentHex: '#2370ED',
    subtitle: 'RISK LEVEL 2/10',
    description:
      'You prioritize stability and want to minimize exposure to market volatility. While this approach may result in lower returns, it provides a more predictable investment experience.',
    descriptionSecondary: 'Your portfolio consists primarily of highly-rated bonds.',
    image: defensiveImg,
  },
  {
    slug: 'defensive',
    displayName: 'Defensive',
    riskLevel: 1,
    accentHex: '#2370ED',
    subtitle: 'RISK LEVEL 1/10',
    description:
      'You prioritize stability and want to minimize exposure to market volatility. While this approach may result in lower returns, it provides a more predictable investment experience.',
    descriptionSecondary: 'Your portfolio consists primarily of highly-rated bonds.',
    image: defensiveImg,
  },
]

// Optional helpers
export const profileBySlug = Object.fromEntries(
  riskProfiles.map((p) => [p.slug, p])
)
